// [2024-06-13] Niklas Andreasson:
// This component was created to provide defaults that are compatible with the DatePicker components.
// Since MUI dialogs have a focus trap enabled by default (trying to ensure that the focus stays within the dialog), it can cause issues when the Datepicker dialog is used in a modal.
//
// RangeError: Maximum call stack size exceeded.
// at windowObject.HTMLElement.focus \(chunk-...js)
// at HTMLDocument.onFocus \(chunk-...js)
// at windowObject.HTMLElement.focus \(chunk-...js)
// at HTMLDocument.contain2 \(chunk-...js)
// at windowObject.HTMLElement.focus \(chunk-...js)
// at HTMLDocument.onFocus \(chunk-...js)
// at windowObject.HTMLElement.focus \(chunk-...js)
// at HTMLDocument.contain2 \(chunk-...js)
// at windowObject.HTMLElement.focus \(chunk-...js)
// at HTMLDocument.onFocus \(chunk-...js)

import { Dialog as MUIDialog } from '@mui/material'
import React from 'react'

declare module '@mui/material/Dialog' {
  interface DialogPaperSlotPropsOverrides {
    'data-testid'?: string
  }
}

type DialogProps = React.ComponentProps<typeof MUIDialog>

export function Dialog(props: DialogProps): React.ReactElement {
  const { disableEnforceFocus = true, ...restProps } = props

  return <MUIDialog {...restProps} disableEnforceFocus={disableEnforceFocus} />
}
